import { combineReducers } from 'redux';

import { createRequestStateReducer } from 'src/store/helpers';

import { licenceActions } from './actions';

export const licenceReducer = combineReducers({
  getLicenceInfo: createRequestStateReducer(licenceActions.getLicenceInfo),
});
